import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const UpdateMenu = ({ 
  formData, 
  handleChange, 
  handleSubmit, 
  onCancel,
  loading, 
  error 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">Edit Menu</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="border w-full p-2 rounded"
              required
              maxLength="255"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">URL</label>
            <input
              type="url"
              name="url"
              value={formData.url}
              onChange={handleChange}
              className="border w-full p-2 rounded"
              required
              maxLength="500"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Menu Type</label>
            <select
              name="menu_type"
              value={formData.menu_type}
              onChange={handleChange}
              className="border w-full p-2 rounded"
              required
            >
              <option value="header">Header</option>
              <option value="footer">Footer</option>
              <option value="sidebar">Sidebar</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Order</label>
            <input
              type="number"
              name="order"
              value={formData.order}
              onChange={handleChange}
              className="border w-full p-2 rounded"
              min="1"
              required
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? 'Updating...' : 'Update Menu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateMenu;